var map = {
	"./1.jpg": 5031,
	"./10.jpg": 5098,
	"./11.jpg": 690,
	"./2.jpg": 4955,
	"./3.jpg": 6291,
	"./4.jpg": 3298,
	"./5.jpg": 1550,
	"./6.jpg": 8774,
	"./7.jpg": 5463,
	"./8.jpg": 6879,
	"./9.jpg": 8355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4322;